import React, { useEffect, useState } from 'react';
import { green_star, grey_star } from '../../utils/images';

function Notation(props) {
	const [starsCount, setStarsCount] = useState(props.rating);

	useEffect(() => {
		setStarsCount(props.rating);
	}, [props.rating]);

	function onClickStars(index) {
		if (props?.disabled) return;

		setStarsCount(index);
		props.updateReview(index);
	}

	function displayStars() {
		const arrayStars = [];

		for (let i = 1; i <= 5; i++) {
			if (i <= starsCount) {
				arrayStars.push(
					<img
						src={green_star}
						alt="green star"
						className="green-star"
						key={i}
						onClick={() => onClickStars(i)}
					/>
				);
			} else {
				arrayStars.push(
					<img
						src={grey_star}
						alt="grey star"
						className="grey-star"
						key={i}
						onClick={() => onClickStars(i)}
					/>
				);
			}
		}

		return arrayStars;
	}

	return <div className="card-stars">{displayStars()}</div>;
}

export default Notation;
